import TypeSelector from './TypeSelector';
import BlockList from './BlockList';

const BlockSelector = {
    TypeSelector,
    BlockList
};

export default BlockSelector;
